import clsx from "clsx";
import { useLenis } from "lenis/react";
import { usePathname } from "next/navigation";
import { useState, useEffect, useRef } from "react";
import { useApp } from "@/context/AppContext";
import useNavAnimation from "@/hooks/useNavAnimation";
import usePageType from "@/hooks/usePageType";
import NavLink from "./nav-link";
import Cta from "../cta/cta";
import Logo from "../svg/logo";

export default function DesktopNav({ navLinks }) {
  const pathname = usePathname();
  const { isMapPage, isRecordPage, isStoryPage } = usePageType();
  const [activeLink, setActiveLink] = useState(pathname);
  const [hasScrolledHalf, setHasScrolledHalf] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const isClickDisabledRef = useRef(false);
  const { headerHeight, isRouteChanging, isMobile } = useApp();
  const headerHeightRef = useRef(headerHeight);

  const { nav } = useNavAnimation({
    isRouteChanging,
    isMapPage,
    isRecordPage,
    isStoryPage,
    isMobile,
    mediaQuery: "(prefers-reduced-motion: no-preference) and (min-width: 1024px)"
  });

  const handleScroll = ({ scroll }) => {
    setHasScrolledHalf(scroll > 0.5 * headerHeightRef.current);
    setHasScrolled(scroll > 0.5 * headerHeightRef.current);
  };

  const handleLinkClick = (href) => {
    setActiveLink(href);
    isClickDisabledRef.current = true;
  };

  useEffect(() => {
    const parts = pathname.split('/');
    const normalizedPath = parts.length > 3 ? parts.slice(0, 3).join('/') : pathname;
    setActiveLink(normalizedPath)
  }, [pathname])

  useLenis(handleScroll);

  useEffect(() => {
    headerHeightRef.current = headerHeight;
  }, [headerHeight]);

  return (
    <nav
      className={clsx("max-lg:hidden flex gap-(--space-8) w-full h-full items-center justify-center t-colors pointer-events-auto", !hasScrolledHalf ? '!delay-500' : 'drop-shadow-thin', '-translate-y-[200%]')}
      ref={nav}
    >
      <div className="flex gap-(--space-8) w-full h-full items-center justify-center px-(--space-7) max-w-480 relative">
        <a href="https://www.ancestry.com/" className={clsx('mr-auto', hasScrolled ? 'opacity-in' : 'opacity-out pointer-events-none')}>
          <Logo  />
        </a>

        {navLinks.map(({ label, href, underlineSize, desktopHeaderUnderlineScale, transitionName = "base" }) => (
          <NavLink
            key={href}
            label={label}
            href={href}
            underlineSize={underlineSize}
            underlineScale={desktopHeaderUnderlineScale}
            transitionName={transitionName}
            isActive={activeLink === href}
            onClick={() => handleLinkClick(href)}
          />
        ))}
        <Cta href="https://ancestry.com/story-scout" className={clsx("ml-auto cta-big", hasScrolled ? 'opacity-in' : 'opacity-out pointer-events-none')}>Now find your story</Cta>
      </div>
    </nav>
  )

}
